
import $ from 'jquery';
import plugin from '@core/plugins/lib';

export const ELEMENT_SELECTOR = '[data-checkbox-set]';
export const PLUGIN_NAME = 'CheckboxSet';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(/* webpackChunkName: "checkbox-set" */ './checkbox-set'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/checkbox-set/index.js